import { BookingModel } from "../../models/Bookings";
import { Event } from "../../models/Event";
import { EventCategory } from "../../models/EventCategory";
import { TargetBeneficiary } from "../../models/TargetBeneficiary";

export interface eventStateInterface {
  events: Event[];
  selectedBookings: BookingModel[];
  selectedCategories: EventCategory[];
  selectedTargetBeneficiaries: TargetBeneficiary[];
  lastCursor: string;
  loading: boolean;
}

const initState: eventStateInterface = {
  events: [],
  selectedBookings: [],
  selectedCategories: [],
  selectedTargetBeneficiaries: [],
  lastCursor: "",
  loading: false,
};

const eventsReducer: any = (state = initState, action: any) => {
  switch (action.type) {
    case "UPDATE_EVENT_LIST":
      return {
        ...state,
        events: action.payload.events,
        lastCursor: action.payload.lastCursor,
      };
    case "UPDATE_EVENT_LIST_ATTRIBUTES":
      return {
        ...state,
        selectedCategories: action.payload.selectedCategories,
        selectedTargetBeneficiaries: action.payload.selectedTargetBeneficiaries,
      };
    case "UPDATE_SELECTED_EVENT_BOOKINGS":
      return {
        ...state,
        selectedBookings: action.payload.selectedBookings,
      };
    case "UPDATE_EVENT_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };
    default:
      return state;
  }
};

export default eventsReducer;
